module.exports = __webpack_public_path__ + "img/login_logo.b6daa83e.svg";